import type { RegistrationStep, StrapiFile } from '@/models';

export enum Civility {
  civility1 = 'civility_1',
  civility2 = 'civility_2'
}

export enum Committee {
  france = 'france',
  america = 'america',
  japan = 'japan',
  china = 'china',
  korea = 'korea',
  europe_others = 'europe_others',
  asia_others = 'asia_others'
}

export enum SocialNetwork {
  instagram = 'instagram',
  tiktok = 'tiktok',
  youtube = 'youtube',
  red = 'red',
  wechat = 'wechat'
}

export type User = {
  jwtToken?: string;
  id?: number;
  documentId?: string;
  email: string;
  confirmed?: boolean;
  blocked?: boolean;
  createdAt?: string;
  updatedAt?: string;
  publishedAt?: string;
  firstName?: string;
  birthDate?: string;
  phoneNumber?: string;
  jobTitle?: string;
  chestSize?: number;
  waistSize?: number;
  recipeName?: string;
  cabbageContestSource?: string;
  civility?: Civility;
  lastName?: string;
  socialNetworksList?: SocialNetwork;
  restaurantName?: string;
  restaurantAddress?: string;
  restaurantZipCode?: string;
  restaurantCity?: string;
  restaurantCountry?: string;
  restaurantWebSite?: string | null;
  restaurantInstagramPseudo?: string;
  hipsSize?: number;
  recipeDescription?: string;
  recipeIngredientsList?: string;
  recipeEquipmentList?: string;
  contestOtherQuestions?: string;
  username?: string;
  socialNetworkPseudo?: string;
  committee?: Committee;
  provider: 'local';
  applicationConfirmedEmailSent?: boolean;
  currentStepSlug?: RegistrationStep;
  language?: string;
  marketingAccepted?: boolean;
};

export type UserWithDocuments = Pick<User, 'id' | 'documentId'> & {
  identityPhoto?: StrapiFile;
  passportPhoto?: StrapiFile;
  cv?: StrapiFile;
};

export type UserWithRecipePhotos = Pick<User, 'id' | 'documentId'> & { recipePhotos: StrapiFile[] };
